// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden-text":"VisuallyHiddenText_visually-hidden-text__3Gujc"};